<template>
	<div>
		<TableList :columns="columns" :get_table_list="this.get_table_list" :form_data_seo="form_data_seo"
			:slot_table_list="['operation','status','city']" :submit_preprocessing="submit_preprocessing" ref="list"
			:rowKey="'id'">
			<template slot="left_btn">
				<div class="left_btn_box">
					<div class="recharge_all">
						<p>打卡数量<span class="all_money">{{all_data.total}}</span></p>
						<p>异常打卡数量<span class="all_money">{{all_data.unusual}}</span></p>
					</div>
				</div>
			</template>
			<template slot="right_btn">
				<a :href="'/manage/crm.trip/exportPlaceClock' | export_form"  target="_blank">
					<a-button  class="a_btn">导出</a-button>
				</a>
			</template>
			<template slot="operation" slot-scope="data">
				<span>
					<a @click="see(data.record)">查看</a>
				</span>
			</template>
		</TableList>

	</div>
</template>

<script>
	// @ is an alias to /src
	import EditPop from "@/components/EditPop";
	import Form from "@/components/Form";
	import TableList from "@/components/TableList";
	import SelectUser from "@/components/SelectUser";

	import {
		placeClock,
		clockCensus,
        placeClockCount
	} from "@/api/evection";
	import {
		getUserList
	} from "@/api/personnel";

	const columns = [{
			title: "员工姓名",
			dataIndex: "username"
		},
		{
			title: "部门",
			dataIndex: "department_name"
		},
		{
			title: "出发地",
			dataIndex: "start_place"
		},
		{
			title: "出发打卡",
			dataIndex: "start_clock",

		},
		{
			title: "到达地",
			dataIndex: "end_place",
		},

		{
			title: "到达打卡",
			dataIndex: "end_clock",
		},

		{
			title: "操作",
			dataIndex: "operation",
			scopedSlots: {
				customRender: "operation"
			}
		}
	];



	export default {
		name: "Index",
		components: {
			EditPop,
			Form,
			TableList,
			SelectUser
		},
		data() {
			return {
				config: this.$config,
				get_table_list: placeClock,
				submit_preprocessing: {
					array_to_string: ['department_id', 'group_id']
				},
				columns,
				selectedRowKeys: [],
				loading: false,
				visible: false,
				form_data_seo: {
					list: [

						{
							type: "text",
							name: "keyword",
							title: "员工姓名",
							placeholder: "请输入员工姓名",
							options: {}
						},
						{
							type: "tree-select",
							name: "department_id",
							title: "部门",
							options: {},
							treeData: [],
							multiple: true
						},
						
						{
							type: 'select',
							title: '出发打卡状态',
							name: 'start_status',
							options: {},
							list: [{
									key: '1',
									value: "已打卡"
								},
								{
									key: '0',
									value: "未打卡"
								},
								
							]
						},
						{
							type: 'select',
							title: '到达打卡状态',
							name: 'end_status',
							options: {},
							list: [{
									key: '1',
									value: "已打卡"
								},
								{
									key: '0',
									value: "未打卡"
								},
								
							]
						},
						// {
						// 	type: "range_date",
						// 	name: "",
						// 	title: "入住时间",
						// 	options: {},
						// 	start: {
						// 		name: 'start_time'
						// 	},
						// 	end: {
						// 		name: 'end_time'
						// 	},
						// },

					],
					...this.$config.form_data_seo
				},
				all_data: {}
			};
		},


		async created() {
			this.get_info()
			Promise.all([this.$method.get_department()]).then(
				res => {
					this.form_data_seo.list.forEach(item => {
						if (item.name == "department_id") {
							item.treeData = res[0];
						}
					});
				});
			
		},
		methods: {
			see(key) {
				this.$router.push("/evection/trip_clock_details?id=" + key.id);
			},
			get_info() {
				placeClockCount().then(res => {
					this.all_data = res.data.data
				})
			},

		}
	};
</script>

<style lang="less">
	@import url("../../assets/less/app.less");

	.left_btn_box {
		flex: inherit;

		p {
			margin: 5px 0px;
		}
	}

	.edit_pop {
		.ant-col-19 {
			width: 77%;
		}

		.ant-form-item-label {
			width: 22%;
		}
	}

	.red_color {
		color: red;
	}

	.green_color {
		color: #00CC10;
	}

	.recharge_all {
		font-size: 16px;
		display: flex;
		color: #333;

		.all_money {
			font-size: 20px;
			color: #FF0000;
			margin-left: 10px;
			margin-right: 5px;
			display: inline-block;
		}

		p:nth-child(2),p:nth-child(3) {
			margin-left: 40px;
		}
	}
</style>
